/* Uberflip GWL OB-9717 start here */
function changeText() {
    const twitterLink = document.querySelector('.author-bio-link.uf-author-twitter');
    if (twitterLink) {
        const currentText = twitterLink.innerText;
        const newText = currentText.replace("Twitter", "X");
        twitterLink.innerText = newText;
    }
}
export { changeText };
/* Uberflip GWL OB-9717 end here */


// WEBPACK FOOTER //
// ./scriptPartials/linkUpdate.js